import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import View from './view';
import * as Actions from './actions';
import * as RosterSelectors from 'shared_redux/selectors/view/roster';
import { getEffectiveOrganizationId } from 'shared_redux/selectors/view/organization_switcher';

const mapStateToProps = (state, props) => {
    return {
        models: RosterSelectors.getRosterFilterViewModels(state, props),
        organizationId: getEffectiveOrganizationId(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchTeams: Actions.fetchTeams,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default withRouter(Container);
